import React from 'react'
import LanguageContext from '../helper/LanguageContext';
import { IoIosNotificationsOutline } from 'react-icons/io';

function InvitationProjectsCard({ pendingRequests, onClick }) {
    const { strings } = React.useContext(LanguageContext);
    return (
        <div onClick={onClick} className="invitation-pending-card">
            <span className="invitation-pending-bell">
                <IoIosNotificationsOutline
                    size={30}
                    color="#737373"
                />
                {pendingRequests > 0 ? (
                    <span className="invitation-pending-count">{pendingRequests}</span>
                ) : null}
            </span>
            <span className="invitation-pending-label">
                {strings.request_confirmation}
            </span>
        </div>
    )
}

export default InvitationProjectsCard